import ListContentView from './ListContentView';
import NumberedListContentView from './NumberedListContentView';
import TableContentView from './TableContentView';
import TextContentView from './TextContentView';
import {type SectionListItem} from './types';

type SectionViewContentProps = {
  item: SectionListItem;
  paragraphName: string | number;
};

function SectionViewContent({item, paragraphName}: SectionViewContentProps) {
  switch (item.type) {
    case 'text':
      return <TextContentView content={item.content} />;

    case 'list':
      return <ListContentView items={item.items} />;

    case 'numberedList':
      return (
        <NumberedListContentView
          items={item.items}
          paragraphName={paragraphName}
        />
      );

    case 'table':
      return <TableContentView headers={item.headers} rows={item.rows} />;

    default: {
      const unhandled: never = item;

      throw new Error(`Unknown type ${JSON.stringify(unhandled)}`);
    }
  }
}
export default SectionViewContent;
